/**
 * Registra manejadores antes de React para captar fallos sin mensaje
 * («Script error» / «Error de script») y promesas no capturadas.
 * Debe importarse lo antes posible en index.js.
 */
function reasonToText(reason) {
  if (reason == null) return "(valor nulo)";
  if (reason instanceof Error) {
    const m = (reason.message || "").trim();
    return m || `${reason.name || "Error"} (sin mensaje). Revise la consola (F12) para el stack.`;
  }
  if (typeof reason === "string") return reason.trim() || "(cadena vacía)";
  try {
    const s = JSON.stringify(reason);
    return s && s !== "{}" ? s : String(reason);
  } catch {
    return String(reason);
  }
}

function isBenignScriptErrorMessage(msg) {
  const m = String(msg || "").trim().toLowerCase();
  return (
    m === "script error." ||
    m === "script error" ||
    m === "error de script." ||
    m === "error de script" ||
    m === "uncaught exception: script error."
  );
}

export function installGlobalErrorHandlers() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const text = reasonToText(event.reason);
      // eslint-disable-next-line no-console
      console.error("[ICJEME] Promesa no capturada:", text, event.reason);
      try {
        event.preventDefault();
      } catch {
        /* ignore */
      }
      const el = document.getElementById("icjeme-runtime-error-banner");
      if (el) {
        el.textContent = `Error: ${text}`;
        el.hidden = false;
      }
    },
    true,
  );

  window.addEventListener(
    "error",
    (event) => {
      const msg = event?.message || "";
      const err = event?.error;
      // Siempre loguear con prefijo: el overlay de CRA a menudo solo muestra «Error de script.»
      // eslint-disable-next-line no-console
      console.error("[ICJEME] window.error (captura):", {
        message: msg || "(vacío)",
        filename: event?.filename || "",
        lineno: event?.lineno,
        colno: event?.colno,
        errorName: err?.name,
        errorMessage: err?.message,
        stack: err?.stack,
      });
      if (isBenignScriptErrorMessage(msg)) {
        // eslint-disable-next-line no-console
        console.warn(
          "[ICJEME] «Error de script» / mensaje vacío: a menudo es un script de otro origen (p. ej. CDN), extensión del navegador, o mezclar localhost con 127.0.0.1. Mire arriba filename/lineno; si no es /static/js/bundle.js, no es su código React.",
        );
      }
    },
    true,
  );
}

/** Registro inmediato al importar el módulo: corre antes que otros imports pesados del entry (p. ej. App). */
if (typeof window !== "undefined") {
  installGlobalErrorHandlers();
}
